import classNames from 'classnames';

import GoalSubscriptionStatusChip from '@components/goals/GoalSubscriptionStatusChip';
import UserCardShell, { UserCardDateBadge } from '@components/goals/UserCardShell';
import GoalProgressBar from '@components/progress/GoalProgressBar';
import { GoalSubscriptionModel } from '@models/goalSubscriptions';
import UserAvatar from '@shared/UserAvatar';
import { setupForDark } from '@theme';

function ImproverSubscriptionCard({
  goalSubscription,
  onClick
}: {
  goalSubscription: GoalSubscriptionModel;
  onClick?: () => void;
}) {
  return (
    <UserCardShell data-testid='improver-subscription-card' onClick={onClick}>
      <div className='flex flex-row items-center gap-xs'>
        <GoalSubscriptionStatusChip status={goalSubscription.status} />
        <div className='flex-1' />
        {goalSubscription.createdAt && <UserCardDateBadge date={goalSubscription.createdAt} />}
      </div>

      <div className='flex flex-row items-center gap-sm'>
        <UserAvatar
          pictureUrl={goalSubscription.user?.pictureUrl}
          size={56}
          isProducer={false}
          isMaster={false}
          isChatbot={false}
        />
        <div
          className={classNames(
            'min-w-0 flex flex-col items-start gap-xs w-full',
            setupForDark('text-primary')
          )}
        >
          {/* RESPONSIVE STYLES */}
          <div className='P3M sm:P2M truncate w-full'>{goalSubscription.user?.name}</div>
          {goalSubscription.progress && (
            <GoalProgressBar
              goalEntityId={goalSubscription.progress.goalEntityId}
              progress={goalSubscription.progress}
              enableRealtimeUpdates={false}
            />
          )}
        </div>
      </div>
    </UserCardShell>
  );
}

export default ImproverSubscriptionCard;
